import { useState } from 'react';

interface ShareDialogProps {
  isOpen: boolean;
  onClose: () => void;
  folder?: {
    id: number;
    name: string;
    reports?: any[];
  };
  report?: {
    id: string;
    name: string;
  };
}

export function ShareDialog({ isOpen, onClose, folder, report }: ShareDialogProps) {
  const [activeTab, setActiveTab] = useState(0);
  const [showTabs, setShowTabs] = useState(true);

  const tabs = [
    { name: 'My Clients', id: 'clients' },
    { name: 'External', id: 'external' },
  ];

  const handleClose = () => {
    setActiveTab(0);
    setShowTabs(true);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-full max-w-4xl bg-white rounded-lg shadow-xl" style={{ width: '70%' }}>
        {/* Header */}
        <div className="bg-blue-600 text-white px-6 py-4 rounded-t-lg">
          <div className="flex items-center justify-between">
            <div className="flex-1"></div>
            <h2 className="text-xl font-medium text-center">
              {report
                ? 'Share Report'
                : `Share folder ${folder?.name} (${folder?.reports?.length || 0} items)`}
            </h2>
            <div className="flex-1 flex justify-end">
              <button onClick={handleClose} className="p-1 text-white hover:bg-blue-700 rounded">
                <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Tab Navigation */}
        {showTabs && (
          <div className="border-b border-gray-200">
            <nav className="flex">
              {tabs.map((tab, index) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(index)}
                  className={`flex-1 py-4 px-6 text-sm font-medium border-b-2 ${
                    activeTab === index
                      ? 'border-black text-black'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  {tab.name}
                </button>
              ))}
            </nav>
          </div>
        )}

        {/* Content */}
        <div className="p-6 min-h-[400px]">
          {activeTab === 0 && (
            <div className="text-center text-gray-500 py-20">
              My Clients sharing functionality coming soon...
            </div>
          )}
          {activeTab === 1 && (
            <div className="text-center text-gray-500 py-20">
              External sharing functionality coming soon...
            </div>
          )}
        </div>
      </div>
    </div>
  );
}